import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  DialogActions,
  Snackbar,
  Alert,
} from "@mui/material";
import Button from "@mui/material/Button";
import { ChangeEvent, FormEvent, useCallback, useState } from "react";
import { useManageModal } from "src/hooks/useManageModal";
import { useSentryLogger } from "src/hooks/useSentryLogger";
import { supabaseClient } from "src/supabase/supabaseClient";

const ResetPatientPassword = () => {
  const logError = useSentryLogger("error");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [openSnack, setOpenSnack] = useState(false);
  const [open, { handleClose, handleOpen }] = useManageModal();
  const handleSubmit = useCallback(
    async (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      if (email === "") return;
      setLoading(true);

      try {
        const { error } = await supabaseClient.auth.resetPasswordForEmail(
          email,
          {
            redirectTo: `${import.meta.env.VITE_REDIRECT_LINK}/update-password`,
          },
        );

        if (error != null) {
          throw error;
        }

        setOpenSnack(true);
        setEmail("");
        handleClose();
      } catch (err: unknown) {
        logError("Could not send reset password email", err);
        setError("Could not send reset password email");
      } finally {
        setLoading(false);
      }
    },
    [email, handleClose, logError],
  );

  const handleCloseSnack = useCallback(() => {
    setOpenSnack(false);
  }, []);

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  }, []);

  return (
    <>
      <Button color="error" variant="text" onClick={handleOpen}>
        Reset Password
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Reset Password</DialogTitle>
        <DialogContent sx={{ width: 400 }}>
          <DialogContentText>Please enter email</DialogContentText>
          <form onSubmit={handleSubmit} id="reset-password-form">
            <TextField
              error={!!error}
              helperText={error}
              required
              margin="dense"
              id="name"
              name="email"
              label="Email Address"
              type="email"
              fullWidth
              variant="standard"
              onChange={handleChange}
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" form="reset-password-form" loading={loading}>
            Reset
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openSnack}
        autoHideDuration={5000}
        onClose={handleCloseSnack}
      >
        <Alert
          onClose={handleCloseSnack}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Successfully sent reset email!
        </Alert>
      </Snackbar>
    </>
  );
};

export default ResetPatientPassword;
